import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import HomeLink from '../components/HomeLink';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import Markdown from '../components/Markdown';
import markdown
  from '../data/staticPages/landing/international-fashion-jobs.md';
import Layout from '../components/Layout';
import Hero from '../components/Hero';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/NKXXc4l1z3A0ZfWDJxI7x_txPVWb7ZLovXpzMxXKROU/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtbW9iaWxlLnBuZw',
    'https://r.fashionunited.com/6l-Aux1zoTAiM0q5LAtfZC1hPBliuepHmIoyM9U6VQ4/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtbW9iaWxlLnBuZw',
    'https://r.fashionunited.com/-4MwtCqJ7tXsP_22q7HjilEIzMpDlkewSOTlxDtK8bE/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtbW9iaWxlLnBuZw',
  ],
  desktop: [
    'https://r.fashionunited.com/dPHqDaTWrh8SNSXjnwB7DI70DXuWw-Ooz62YkERz-08/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtZGVza3RvcC5wbmc',
    'https://r.fashionunited.com/OzL8eHqmCGdQcM-4QbhDDA0IpRAvtYCYRMS3etTyZ4s/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtZGVza3RvcC5wbmc',
    'https://r.fashionunited.com/H_RQsKPWwdtryB2KLX7Me4lCXAy-fnpOykuI9ZGOR5g/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtZGVza3RvcC5wbmc',
    'https://r.fashionunited.com/f4bi8qOqD6iVZCeYeIFrL1bUkU7i3y1ZW_svFTq4E7o/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJuYXRpb25hbC1mYXNoaW9uLWpvYnMtZGVza3RvcC5wbmc',
  ],
};

const InternationalFashionJobsPage = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    'International fashion jobs',
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['internationalFashionJobs.title'])}
        description={intl.formatMessage(
          messages['internationalFashionJobs.description'],
        )}
      />
      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={<Markdown markdown={markdown} allowGfm allowHtml />}
        title={intl.formatMessage(messages['internationalFashionJobs.title'])}
      />
    </>
  );
};

InternationalFashionJobsPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Content marketing banner image"
        imageUrls={headerImageUrls}
      />
    )}
  >
    {page}
  </Layout>
);

export default InternationalFashionJobsPage;
